import { http } from '@pendo/http';

export function fetchFeatures () {
    return http.get('api/s/_SID_/feature?expand=*');
}

export function fetchFeature (featureId) {
    return http.get(`api/s/_SID_/feature/${featureId}`);
}

export function fetchFeaturesIgnoredFrustrations () {
    return http.get('api/s/_SID_/feature/ignorefrustration');
}

export function fetchFeatureGuides (featureId) {
    return http.get(`api/s/_SID_/feature/${featureId}/guide`);
}

export function updateFeature (feature, shouldStartProcessing) {
    return http.put(`api/s/_SID_/feature/${feature.id}`, feature).then(async (updatedFeature) => {
        if (shouldStartProcessing) {
            try {
                await startProcessingFeature(feature.id);
            } catch (error) {
                const reverseProcessingJobIsAlreadyRunning = error.response.status === 409;
                if (!reverseProcessingJobIsAlreadyRunning) {
                    throw error;
                }
            }
        }

        return updatedFeature;
    });
}

export function updateFeatureIgnoredFrustrations ({ id, ignoredFrustrationTypes }) {
    return http.put(`api/s/_SID_/feature/${id}/ignorefrustration`, { ignoredFrustrationTypes });
}

export function createFeature (newFeature, shouldStartProcessing = true) {
    return http.post('api/s/_SID_/feature', newFeature).then((savedFeatureResponse) => {
        const savedFeature = savedFeatureResponse.data;
        if (shouldStartProcessing) {
            startProcessingFeature(savedFeature.id);
        }

        return savedFeatureResponse;
    });
}

export function deleteFeature (featureId) {
    return http.delete(`api/s/_SID_/feature/${featureId}`);
}

export function startProcessingFeature (featureId) {
    return http.post(`api/s/_SID_/feature/${featureId}/apply`, null);
}
